import React from "react";
import { ItemProvider } from "./ItemPageShared/itemContext";
import ItemPage from "./ItemPage";
import { ToastContainer } from "react-toastify";

const ItemPageWrapper = () => {

    return (
        <ItemProvider>
            {/* <ToastContainer /> */}
            <ItemPage/>
        </ItemProvider>
    )
};

export default ItemPageWrapper;